import { Step } from '@acorns/web-components'
import * as H from 'history'

export type Flow =
  | 'core'
  | 'later'
  | 'laterOnboarding'
  | 'spend'
  | 'tiered'
  | 'directToMobile'
  | 'mightyOakCardOnboarding'

export type FlowProviderProps = {
  history: H.History
  location: H.Location
  visitedPages?: string[]
}

export type FlowProviderState = {
  userState: any
}

export type FlowProviderRedirectConfig = {
  from?: FlowRoute
  action: string
  path?: FlowRoute
  state?: any
  locationState?: any
  forwardQueryParams?: boolean
  doNotTrackVisited?: boolean
  queryParams?: object
}

export type FlowEntryAction = {
  name: string
  stepEvent?: string
  goTo: (state: any, props: any) => FlowRoute
}

export type FlowProgress = {
  stepIndex?: number
  stepPartialProgress?: number
  stepOverallProgress?: number
}

export type FlowProgressWithSteps = FlowProgress & {
  steps: Step[]
}

export type FlowEntry = {
  page: FlowRoute
  progress?: FlowProgress
  actions: FlowEntryAction[]
}

export enum FlowRoute {
  Analyzing = '/analyzing',
  BankLinkSuccess = '/bank-link-success',
  CardOrderReview = '/card-order-review',
  ChooseFundingSource = '/choose-funding-source',
  ContactInfo = '/contact-info',
  CryptoLander = '/crypto/lander',
  Funding = '/funding',
  Institutions = '/institutions',
  DirectBankIntegration = '/institution/link',
  DirectBankIntegrationRedirect = '/institution/redirect',
  InvestInterstitial = '/invest-interstitial',
  InvestorQuestions = '/investor-questions',
  LaterIraRecommendation = '/later-ira-recommendation',
  LaterOnboardingQuestions = '/later-onboarding-questions',
  LaterSuitabilityQuestions = '/later-suitability-questions',
  ManualFundingSource = '/manual-funding-source',
  MOCInterstitial = '/moc-interstitial',
  MOCProgressStepOne = '/moc-progress-step-1',
  MOCProgressStepTwo = '/moc-progress-step-2',
  MOCProgressStepThree = '/moc-progress-step-3',
  MOCReferralReminder = '/moc-referral-reminder',
  MOCSuccess = '/moc-success',
  MFASetup = '/mfa-setup',
  DirectToMobileLander = '/direct-to-mobile',
  OneTimeInvestment = '/one-time-investment',
  OneTimeDeposit = '/one-time-deposit',
  PersonalInfo = '/personal-info',
  Portfolio = '/portfolio',
  PortfolioOverview = '/portfolio-overview',
  PortfolioRecommendation = '/portfolio-recommendation',
  SelectPortfolioTheme = '/select-portfolio-theme',
  PreviewPortfolio = '/preview-portfolio',
  ESGEducationFlow = '/esg-education-flow',
  AboutESG = '/about-esg-portfolios',
  AboutPortfolio = '/about-portfolio',
  Occupation = '/occupation',
  Prefund = '/prefund',
  PricingInterstitial = '/pricing-interstitial',
  RecurringInvestment = '/recurring-investment',
  RecurringDeposit = '/recurring-deposit',
  ReferralDisclosure = '/referral-disclosure',
  ReferralReward = '/referral-reward',
  RoundUpsInterstitial = '/round-ups-interstitial',
  RoundUpsSetup = '/round-ups-setup',
  RoundUpsFunding = '/round-ups-funding',
  RoundUpsPast = '/round-ups-past',
  SecondChanceBankLink = '/second-chance-bank-link',
  SelectTier = '/select-tier',
  ShippingAddress = '/shipping-address',
  Signup = '/signup',
  SignYourCard = '/sign-your-card',
  SpendOrderConfirmation = '/spend-order-confirmation',
  SpendCoreInterstitial = '/spend-core-interstitial',
  SSN = '/ssn',
  Success = '/success',
  SuitabilityQuestions = '/suitability-questions',
  SuitabilityInterstitial = '/suitability-interstitial',
  Welcome = '/',
  PlaidLinkRedirect = '/plaid-link-redirect',
}
